import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ReceiveOrderReportData} from "./receive-order-report.data";

@Injectable()
export class ReceiveOrderReportModel extends ReportModel<ReceiveOrderReportData> {
    constructor(injector: Injector) {
        super(injector, ReceiveOrderReportData)
    }
}
